import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'
import abcjsObj from 'abcjs'

class Abcjs extends PureComponent {
  uniqueNumber = Date.now() + Math.random()

  renderAbcNotation(abcNotation, parserParams, engraverParams, renderParams, titleFontSize) {
    // abcjs's own default title size (20px) reads oversized against the often
    // fairly narrow (170-200px) note boxes this app renders in tooltips etc.,
    // so it's applied here as a `format.titlefont` override — a bare number
    // keeps abcjs' default face/weight/style and just changes the size (see
    // abcjs' getFontParameter's "format 2: number only" handling). Passing
    // titleFontSize={null} opts back out to abcjs' own default.
    const format = titleFontSize
      ? { ...engraverParams?.format, titlefont: titleFontSize }
      : engraverParams?.format;
    const mergedEngraverParams = format ? { ...engraverParams, format } : engraverParams;

    const res = abcjsObj.renderAbc(
      'abcjs2-result-' + this.uniqueNumber,
      abcNotation,
      parserParams,
      mergedEngraverParams,
      renderParams
    )
  }

  componentDidMount() {
    const { abcNotation, parserParams, engraverParams, renderParams, titleFontSize } = this.props
    this.renderAbcNotation(abcNotation, parserParams, engraverParams, renderParams, titleFontSize)
  }

  componentDidUpdate() {
    const { abcNotation, parserParams, engraverParams, renderParams, titleFontSize } = this.props
    this.renderAbcNotation(abcNotation, parserParams, engraverParams, renderParams, titleFontSize)
  }

  render() {
    return (
     /*  <div style={{ width: '100%' }}> */
        <div>
        <div id={'abcjs2-result-' + this.uniqueNumber} style={{ width: '100%' }} />
      </div>
    )
  }
}

Abcjs.propTypes = {
  abcNotation: PropTypes.string,
  parserParams: PropTypes.object,
  engraverParams: PropTypes.object,
  renderParams: PropTypes.object,
  titleFontSize: PropTypes.number,
}

Abcjs.defaultProps = {
  abcNotation: '',
  parserParams: {},
  engraverParams: { responsive: 'resize' },
  renderParams: { viewportHorizontal: true },
  titleFontSize: 18,
}

export default Abcjs